import { Typography, Button, Link, LinearProgress } from '@material-ui/core';
import '../styles/Globales.scss';
import '../styles/Mensaje.scss';

import React, { Component } from 'react';
import ListaProductoResumenComponent from './utils/ListaProductoResumenComponent';
import appStore from '../stores/AppStore';
import RetractoComponent from './utils/RetractoComponent';
import PopupRetractoTotal from './utils/PopupRetractoTotal';
import ViewConstants from '../utils/ViewConstants';
import PopupSolicitudCanceladaComponent from './utils/PopupSolicitudCanceladaComponent';
import { observer } from 'mobx-react';

const SI = 'SI';
class MensajeRetractoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPopuRetracto: false,
      compromisoRetracto: false,
      oferta: {},
      openCancelada: false,
    };
  }

  componentDidMount = () => {
    this.cargarOfertaAceptada();
  };

  cargarOfertaAceptada = () => {
    appStore.ofertasStore.cargarOfertaAceptada(this.onOfertaCargada, this.onFailCargarOferta);
  };

  onOfertaCargada = () => {
    this.setState({ oferta: appStore.ofertasStore.oferta }, this.checkSinProductos);
  };

  checkSinProductos = () => {
    if (this.state.oferta) {
      const ofertaCredito = this.state.oferta.ofertaCredito;
      const ofertaCuenta = this.state.oferta.ofertaCuenta;
      const ofertaTarjeta = this.state.oferta.ofertaTarjeta;
      if (!ofertaCredito && !ofertaCuenta && !ofertaTarjeta) {
        this.showPopUpSolicitudCancelada();
      }
    }
  };

  showPopUpSolicitudCancelada = () => {
    this.setState({ openCancelada: true });
  };

  onFailCargarOferta = () => {
    this.onVolver();
  };

  formatNumeroSolicitud = (value) => {
    let result = '';
    if (value) {
      result = result + value;
    }

    while (result.length < 10) {
      result = '0' + result;
    }
    return result;
  };

  generarCertificado = () => {
    const solicitudId = appStore.solicitarNuevaPortalidadStore.solicitudId;
    appStore.solicitarNuevaPortalidadStore.generarCertificadoPorId(solicitudId, this.onCertificadoOk, this.onCertificadoFail);
  };

  onCertificadoOk = (pdf) => {
    const pdfName = 'data:application/pdf;base64,' + pdf;
    const link = document.createElement('a');
    link.href = pdfName;
    link.setAttribute('download', 'solicitud_portabilidad');
    link.click();
  };

  onCertificadoFail = () => {};

  onClosePopupRetracto = () => {
    this.setState({ openPopuRetracto: false });
  };

  onChangeQuieroRetractar = (value) => {
    if (value === SI) {
      this.setState({ openPopuRetracto: true, compromisoRetracto: false });
    } else {
      this.setState({ compromisoRetracto: true });
    }
  };

  onAceptar = () => {
    appStore.ofertasStore.compromisoNoRetracto(this.state.compromisoRetracto, this.onCompromisoResult);
  };

  onCompromisoResult = () => {
    appStore.cargarSolicitudesCliente(this.onSolicitudesCargadas, 0);
  };

  onSolicitudesCargadas = () => {
    appStore.changeNavigation(ViewConstants.ETAPA_LISTADO_SOLICITUDES);
  };

  onVolver = () => {
    appStore.changeNavigation(ViewConstants.ETAPA_LISTADO_SOLICITUDES);
  };

  retractoEjecutado = () => {
    this.setState({ openPopuRetracto: false }, this.cargarOfertaAceptada);
  };

  onCerrarPopUpCancelada = () => {
    this.setState({ openCancelada: false }, this.onCompromisoResult);
  };

  render() {
    let credito;
    let cuenta;
    let tarjeta;
    if (this.state.oferta.ofertaCredito && this.state.oferta.ofertaCredito.selected) {
      credito = <ListaProductoResumenComponent producto={this.state.oferta.ofertaCredito} />;
    }
    if (this.state.oferta.ofertaCuenta && this.state.oferta.ofertaCuenta.selected) {
      cuenta = <ListaProductoResumenComponent producto={this.state.oferta.ofertaCuenta} />;
    }
    if (this.state.oferta.ofertaTarjeta && this.state.oferta.ofertaTarjeta.selected) {
      tarjeta = <ListaProductoResumenComponent producto={this.state.oferta.ofertaTarjeta} />;
    }
    return (
      <div className="contenedorPrincipal">
        <Typography className="tituloMensaje">¡Felicidades!</Typography>
        <Typography className="subTituloMensaje">has aceptado la oferta de banco ripley</Typography>
        <LinearProgress variant="determinate" color="secondary" value={6 * (100 / 6)} className="barraProgreso" />
        <Typography className="tituloSolicitud  alinearIzq">Estos son los productos que aceptaste portar</Typography>
        <div className="listaproductos">
          {credito}
          {tarjeta}
          {cuenta}
        </div>

        <Typography className="mensajeEnRojo">
          Aun tienes la opción de arrepentirte de la  aceptación de todos o algunos productos, pero para agilizar la contratación en sucursal, puedes confirmar finalizar el proceso.
        </Typography>
        <RetractoComponent onSeleccionChange={this.onChangeQuieroRetractar}></RetractoComponent>
        <div className="botones btnmensaje">
          <Button onClick={this.onAceptar} color="primary" id="btnVerifica" className="btnRipley">
            aceptar
          </Button>
        </div>
        <Typography className="mensajeEnRojo letrachica">
          Ahora acércate a nuestras oficinas para firmar tus productos y finalizar el proceso.{' '}
          <Link href="https://minisitios-ripleypuntos.ripley.cl/minisitios/ripleypuntosgo/sucursales-abiertas.pdf" target="_blank" rel="noopener" variant="body2" underline="always">
            <strong>Ver Sucursales</strong>
          </Link>{' '}
        </Typography>
        <Typography className="mensajeEnRojo letrachica">
          <strong>Si quieres solicitar un crédito de consumo</strong> sólo podrás hacerlo en las sucursales Banco. Para verlas haz clic en <strong>"Ver Sucursales"</strong> éstas{' '}
          <strong>comienzan por "BR"</strong>. Ejemplo: BR MALL ARICA
        </Typography>
        <PopupRetractoTotal productos={appStore.ofertasStore.oferta} open={this.state.openPopuRetracto} onClose={this.onClosePopupRetracto} onRetractoEjecutado={this.retractoEjecutado} />
        <PopupSolicitudCanceladaComponent open={this.state.openCancelada} onCerrar={this.onCerrarPopUpCancelada} />
      </div>
    );
  }
}

MensajeRetractoComponent.defaultProps = {
  listaProductos: [],
};

export default observer(MensajeRetractoComponent);
